import styled from '@mui/material/styles/styled';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { theme } from '@src/common/styles/Theme';
import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof MuiTooltip> & {
  openPopoverClass?: string;
  isClear?: boolean;
};

export const Tooltip = styled(({ className, isClear: _, ...props }: Props) => (
  <MuiTooltip {...props} placement="top" classes={{ popper: className }}>
    {props.children}
  </MuiTooltip>
))((props: Props) => {
  const isClear = props.isClear ?? false;
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      color: isClear
        ? theme.palette.surface.onSurface
        : theme.palette.surface.inverseOnSurface,
      backgroundColor: isClear
        ? theme.palette.surface.surface
        : theme.palette.surface.inverseSurface,
      padding: theme.spacing['2'],
      ...theme.typography.body.small,
    },
  };
});
